import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBars } from "@fortawesome/free-solid-svg-icons";
import { Link, useLocation } from 'react-router-dom';
import { useState } from 'react';

export default function Header() {

  const currentPage = useLocation().pathname;


    const [headerStyle, setMenuStyle] = useState("header-right");
    const menuClick = () => {
      if (headerStyle === "header-right") {
        setMenuStyle("header-right-dropdown")
      } else {
        setMenuStyle("header-right")
      }
    }

    // random comment
    return (
    <div className="header">
      <a href="/" className="logo">J</a>
      <div className={headerStyle}>
        <Link className={currentPage === '/' ? 'header-active' : 'nav-link'} to="/" >Home</Link>
        <Link className={currentPage === '/projects' ? 'header-active' : 'nav-link'}  to="/projects">Projects</Link>
        <Link className={currentPage === '/contact' ? 'header-active' : 'nav-link'}  to="/contact" >Contact</Link>
        <FontAwesomeIcon onClick={menuClick} className={"overflow-bars"} icon={faBars} /> 
      </div>
    </div>
    )
}